import type {IAdBannerSettings} from 'OK/ads/banner/hook/IBannerJson';

import {IRbAdBannerFullScreenAttrs} from './RbAdBannerFullScreenAttrs';

export class RbAdBannerFullScreenStore {
    public readonly settings: IAdBannerSettings;

    constructor(attrs: IRbAdBannerFullScreenAttrs) {
        this.settings = attrs.settings;
    }
}
